"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = Typography;
exports.TypographyContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "children", "testId"];
var styles = {
  "Typography": "Typography__Typography___1ZUfE"
};
var defaultConfiguration = {
  displayText: {
    spacing: 'l'
  },
  displayTextLarge: {
    spacing: 'xl'
  },
  heading: {
    spacing: 'm'
  },
  paragraph: {
    spacing: 'm'
  },
  sectionHeading: {
    spacing: 'l'
  },
  subheading: {
    spacing: 'm'
  }
};

var TypographyContext = /*#__PURE__*/_react["default"].createContext({});

exports.TypographyContext = TypographyContext;

function Typography(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-text-container' : _ref$testId,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles.Typography, className);
  return /*#__PURE__*/_react["default"].createElement(TypographyContext.Provider, {
    value: defaultConfiguration
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, otherProps, {
    className: classNames,
    "data-test-id": testId
  }), children));
}